import React, { useState, useEffect } from "react";
import CallButton from "../../Telephony/CallButton";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import Scrollbars from "react-custom-scrollbars-2";
import dayjs from "dayjs";
import {
	Avatar,
	Button,
	CircularProgress,
	Divider,
	Grid,
	Link,
	Stack,
	Tooltip,
} from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";
import { isEqual } from "lodash";
import {
	BLUE_MAIL_ICON,
	CALL_BUTTON_ICON,
	CELL_ICON,
	CHAT_ICON,
	COMMON_CALL_ICON,
	COMPANY_ICON,
	FAVORITE_STAR_UNSELECTED,
	FAVORITE_STAR_SELECTED,
	FAVORITE_STAR_DISABLED,
	FLAG_ICON,
	HOME_ICON,
	INFORMATION_ICON,
	MAIL_ICON,
	MESSAGE_ICON,
	MOBILE_ICON,
	NEW_CALL_BUTTON_ICON,
	NEW_VIDEO_CAM_ICON,
	PENCIL_ICON,
	PHONE_ICON,
	SATELITE_ICON,
	SHIP_BADGE_ICON,
	SHIPP_ICON,
	SHORE_BADGE_ICON,
	SHIP_OPERATOR_ICON,
	VIDEO_CAM_ICON,
} from "../../../utils/constants";
import { Box, TextField, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import ListDividers from "./ListDividers";
// import ContactForm from "./contactForm";
import EditIcon from '@mui/icons-material/Edit';
import { getColorForRankAndRoles } from "../../../utils/ColorMapping";
import CachedImage from "../../../components/common/CachedImage";
import Chip from "../../../components/ui/Chip";
import ModalPopup from "../../../components/ui/Modals/ModalMessages/ModalPopup";
import ContactForm from "../AddNewContact/ContactForm";
import { getUserProfileImageUrl, getUserProfileImageUrlThumbnail, isValidImageUrl } from "../../../utils/general";

const MentorBadge = styled(Box)({
	width: 24,
	borderRadius: "50%",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	fontWeight: "bold",
	fontSize: "14px",
	height: 24,
	backgroundColor: "#376AFA",
	color: "#fff",
});



const WelcomeButton = styled(Button)({
	backgroundColor: "#376AFA",
	fontSize: "16px",
	textTransform: "unset",
	width: "40%",
	cursor: "pointer",
	height: "56px",
	"&:hover": {
		backgroundColor: "#114ef5",
	},
});

const DeclineButton = styled(Button)({
	backgroundColor: "#fff",
	fontSize: "16px",
	textTransform: "unset",
	border: "1px solid #376AFA",
	width: "40%",
	cursor: "pointer",
	height: "56px",
});

export function getPhoneIcon(type) {
	if (type === "mobile") {
		return CELL_ICON;
	} else if (type === "satellite") {
		return SATELITE_ICON;
	} else if (type === "land") {
		return PHONE_ICON;
	} else {
		return CELL_ICON;
	}
}

const StyledBadge = styled(Badge)(({ theme }) => ({
	"& .MuiBadge-badge": {
		right: "100%",
		bottom: "20px",
		transform: "scale(1) translate(50%, 50%)",
		width: "2.5rem",
		height: "2.5rem",
	},
}));

const StyledTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: "#376AFA",
		color: "#fff",
		fontSize: "14px",
		padding: "12px",
		font: "Figtree",
		lineHeight: "18px",
		fontWeight: "500",
		borderRadius: "10px",
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: "#376AFA",
		margin: "-7px 0 0 -10px",
	},
}));

const CustomBox = styled(Box)(({ theme }) => ({
	marginX: "2rem",
	// padding: theme.spacing(3),
}));

const StyledTypography = styled(Typography)({
	fontSize: "18px",
	fontWeight: 500,
	fontFamily: 'Figtree-Regular',
	color: "#15194B",
});

const noteSection = (
	<>
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				my: 2,
			}}
		>
		</Box>
	</>
);

const getBadgeIcon = (contact) => {
	if (contact?.contactType === "local") return null;
	let { rankLevel1 } = contact;
	let rankLevel1SmallCase = (rankLevel1 || "").toLowerCase();
	let iconPath;
	switch (rankLevel1SmallCase) {
		case "shore":
			iconPath = SHORE_BADGE_ICON;
			break;
		case "ship":
			iconPath = SHIP_BADGE_ICON;
			break;
		default:
			iconPath = '';
	}

	return (iconPath &&
		<img src={iconPath} alt={`${rankLevel1} badge`} style={{ width: "3rem" }} />
	);
};

const ContactDetailsFunctional = (props) => {
	let { setAddContactMenu, addContactMenu } = props;
	const [contact, setContact] = useState(null);
	const [showEditForm, setShowEditForm] = useState(false);
	useEffect(() => {
		if (props.contact.contact) {
			setContact(props.contact.contact);
		}
	}, []);
	useEffect(() => {
		if (props.currentUserId !== props?.contact?.contact?.userId) {
			if (!isEqual(props?.contact?.contact, contact)) {
				setContact(props?.contact?.contact);
				setShowEditForm(false);
			}
		}
	}, [props.contact, props.currentUserId, contact]);

	const checkIsContactFavourite = () => {
		return props.favourites?.some(
			(favourite) => favourite?.contact?.userId == props.contact?.contact?.userId
		);
	};

	const getFavouriteIconImage = () => {
		if (contact?.favActionInProgress) return FAVORITE_STAR_DISABLED;
		if (checkIsContactFavourite()) return FAVORITE_STAR_SELECTED;
		return FAVORITE_STAR_UNSELECTED;
	};

	const isObjectEmpty = (dataObject) => {
		let isEmpty = true;
		for (let item in dataObject) {
			if (dataObject[item] !== "") {
				isEmpty = false;
				break;
			}
		}
		return isEmpty;
	};

	const isInfoMissing = () => {
		let isEmailAddressExist =
			contact?.emailAddresses && isObjectEmpty(contact?.emailAddresses);
		let isPhoneNumberExist =
			contact?.phoneNumbers && isObjectEmpty(contact?.phoneNumbers);

		return (
			contact &&
			contact.contactType === "local" &&
			(isEmailAddressExist || isPhoneNumberExist)
		);
	};

	const toggleContactTofavourites = (contact) => {
		if (contact?.favActionInProgress) return;

		if (checkIsContactFavourite()) {
			props.removeConversationFromFavourites(
				undefined,
				undefined,
				undefined,
				contact?.userId
			);
		} else {
			props.addConversationToFavourites(
				undefined,
				undefined,
				undefined,
				undefined,
				contact?.userId
			);
		}
	};

	const {
		startConversation,
		selectedDomain,
		callhistory,
		balance,
		userId,
		allProfileImages,
	} = props;


	let phoneNumbers = [];
	if (contact && contact.phoneNumbers) {
		phoneNumbers = Object.keys(contact.phoneNumbers).map((key) => {
			let number = contact.phoneNumbers[key];
			let numberNew = number.toString().replace(/\s/g, "");

			return { key, value: numberNew };
		});
	}

	let sortOrder = ['mobile', 'satellite', 'land'];
	phoneNumbers.sort((a, b) => (sortOrder.indexOf(a.key) - sortOrder.indexOf(b.key)));

	const [imgSrc, setImgSrc] = useState('');

	useEffect(() => {
		fetchProfileImage()
	}, [contact, userId]);

	const fetchProfileImage = async () => {
		let imgsrc
		if (contact?.contactType === 'local') {
			imgsrc = getUserProfileImageUrlThumbnail(userId + contact?.userId)
		}
		else {
			imgsrc = getUserProfileImageUrlThumbnail(contact?.userId)
		}
		if (imgsrc) {
			const isValidSrc = await isValidImageUrl(imgsrc)
			if (isValidSrc) {
				setImgSrc(imgsrc);
			}
			else {
				setImgSrc("")
			}
		}
	};

	if (!contact) {
		return null;
	}

	const hasValidEmail =
		contact?.emailAddress ||
		(contact?.emailAddresses &&
			Object.values(contact.emailAddresses).some(val => val && val.trim() !== ''));


	return (
		<div className="text-center px-5 xs-6">
			<Scrollbars autoHide style={{ height: "90vh" }}>
				<div >
					{!contact.showAcceptIgnoreMsg && (
						<Stack
							gap={1.5}
							flexDirection="row"
							sx={{ position: "absolute", right: "3rem", top: "6%" }}
						>
							{contact?.mentor && <MentorBadge>M</MentorBadge>}
							{
								!contact?.isDirectoryContact && contact.contactType !== "local" &&
								<Tooltip
									title={
										checkIsContactFavourite()
											? "Remove from favorite"
											: "Add to favorite"
									}
									arrow
								>
									<Stack
										flexDirection={"column"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{ position: "relative" }}
									>
										<Box
											component={"img"}
											onClick={() => toggleContactTofavourites(contact)}
											src={getFavouriteIconImage()}
											style={{
												pointerEvents: contact?.favActionInProgress
													? "none"
													: "auto",
												cursor: "pointer",
											}}
										/>
										{contact?.favActionInProgress && (
											<CircularProgress size={30} sx={{ position: "absolute" }} />
										)}
									</Stack>
								</Tooltip>
							}
							{contact?.contactType === 'local' && !showEditForm && <Stack flexDirection='row' alignItems='center' justifyContent='center' onClick={() => setShowEditForm(true)}>
								<EditIcon sx={{ color: '#376AFA', fontSize: '1.5rem', cursor: 'pointer' }} />
							</Stack>}
						</Stack>
					)}
					<div className="d-flex justify-content-center align-items-center flex-column">
						<div>
							<StyledBadge
								overlap="circular"
								anchorOrigin={{
									vertical: "bottom",
									horizontal: "right",
								}}
								badgeContent={getBadgeIcon(contact)}
							>
								<div
									style={{
										display: "inline-block",
										borderRadius: "50%",
										padding: "1px",
										backgroundClip: "content-box",
									}}
								>
									{imgSrc ?
										<img
											src={imgSrc}
											className="w-[65px] h-[65px] flex items-center justify-center rounded-full bg-primarymain text-purple-100 text-size-14"
											alt="img"
										/>
										:
										<div className="w-[65px] h-[65px] flex items-center justify-center rounded-full bg-primarymain text-purple-100 text-size-14">
											{(contact.userName ? contact.userName.split(" ").map((n) => n[0]).join("") : "")}
										</div>
									}
								</div>
							</StyledBadge>
						</div>

						<div className="flex items-center  mx-auto justify-center mt-4 gap-3">
							<Typography
								sx={{ fontSize: "14px", textAlign: 'center', fontWeight: "700", color: "#15194B", whiteSpace: 'nowrap', overflow: 'hidden', fontFamily: 'Figtree-Regular' }}
							>
								{contact.name || contact.userName}{" "}
							</Typography>
							{contact?.aboutMe && (
								<StyledTooltip
									title={contact.aboutMe}
									arrow
									placement="bottom-end"
								>
									<img src={`${INFORMATION_ICON}`} />
								</StyledTooltip>
							)}
						</div>


						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "10px",
								marginTop: "5px",
								justifyContent: "center",
							}}
						>
							{contact?.rankLevel2?.trim().length > 0 && (
								<>
									<Chip label={contact.rankLevel2.trim() || "Personal"} sx={{ backgroundColor: getColorForRankAndRoles(contact), }} />
									<span style={{ fontWeight: "400", fontSize: "13px", color: "#404585" }}>{contact.rankLevel3}</span>
								</>
							)}

							{contact?.isAdmin && (
								<div
									style={{
										color: "#000000",
										fontWeight: "400",
										fontSize: "14px",
									}}
								>
									Admin
								</div>
							)}
						</div>
					</div>
				</div>
				<div
					className="flex items-center justify-center gap-5"
					style={{ width: "100%", marginBottom: "30px", marginTop: "30px" }}
				>
					{!contact.showAcceptIgnoreMsg && contact?.contactType !== "local" && (
						<>
							{contact?.showVOIP && (<div
								className="d-flex flex-column align-items-center mx-8 mb-2"
							>
								<CallButton
									balance={balance}
									callType="voip"
									from={props.emailAddress}
									to={contact.userId}
									closeCallHistory={() => console.log("close call history")}
									toName={contact.userName}
									className="btn btn-success btn-icon-o"
									style={{ color: "#fff", border: "none", background: "none" }}
								>
									<img
										className="mx-auto"
										src={NEW_CALL_BUTTON_ICON}
										style={{
											minWidth: "35px",
											height: "35px",
											marginRight: "2px",
											borderRadius: "50%",
										}}
									/>

								</CallButton>
								<div
									style={{ color: "#15194B", marginTop: "5px", fontSize: "14px" }}
								>
									Call
								</div>
							</div>)}

							{contact?.showVideoCall && (<div
								className="d-flex flex-column align-items-center mx-8  mb-2"
							>
								<CallButton
									balance={balance}
									callType="voip"
									from={props.emailAddress}
									to={contact.userId}
									closeCallHistory={() => console.log("close call history")}
									toName={contact.userName}
									video={true}
									className="btn btn-danger btn-icon-o"
									style={{ color: "#fff", border: "none", background: "none" }}
								>

									<img
										className="mx-auto"
										src={NEW_VIDEO_CAM_ICON}
										style={{
											backgroundColor: "red",
											minWidth: "35px",
											height: "35px",
											marginLeft: "10px",
											borderRadius: "50%",
										}}
									/>
								</CallButton>
								<div
									style={{ color: "#15194B", marginTop: "5px", fontSize: "14px" }}
								>
									Video Call
								</div>
							</div>)}
						</>
					)}
					{contact?.showChats && selectedDomain?.viewModes?.chat && !contact.type && !contact.showAcceptIgnoreMsg && !contact.contactType && (
						<div
							className="d-flex flex-column align-items-center mx-3 mb-2"
						>
							<a
								disabled={
									!contact.showAcceptIgnoreMsg &&
										!contact.waitingForConfirmation
										? false
										: true
								}
								onClick={() => startConversation(contact)}
							>
								<img
									className="mx-auto"
									src={MESSAGE_ICON}
									style={{
										minWidth: "35px",
										height: "35px",
										borderRadius: "50%",

									}}
								/>

							</a>
							<div
								style={{ color: "#15194B", marginTop: "5px", fontSize: "14px" }}
							>
								Connect
							</div>
						</div>
					)}
				</div>
				<CustomBox>
					{contact.contactType === "local" && (
						<>
							{(showEditForm) && (
								<ContactForm {...props} handleCancel={() => setShowEditForm(false)} contactData={props.contact} handleDelete={() => props.remove(contact)} />
							)}
						</>
					)}
					{!showEditForm && <Stack
						flexDirection="column"
						alignItems="center"
						justifyContent="center"
						sx={{ width: "80%", margin: "0 auto" }}
						gap={3}
					>
						{props?.selectedDomain?.viewModes?.voip &&
							props?.selectedDomain?.viewModes?.pstn &&
							phoneNumbers.length >= 1 &&
							phoneNumbers.map((phone, index) => {
								let number;
								if (
									phone.value === "null" ||
									phone.value === "" ||
									phone.value === " " ||
									!phone.value
								) {
									number = "";
									return null;
								} else {
									let indexOfUndefined = phone.value.indexOf("undefined");
									if (indexOfUndefined !== -1) {
										number = phone.value.slice(0, indexOfUndefined);
									} else {
										number = phone.value;
									}
									return (
										<React.Fragment key={index}>
											<Grid container key={index} className="justify-between w-full">
												<Grid className="flex gap-3 lg:w-[80%] xl:w-[60%]">
													<Stack flexDirection="row" gap={1} className="xl:w-[35%] lg:w-[40%]" >
														<img
															loading="lazy"
															width="22px"
															color="#15194B"
															src={getPhoneIcon(phone.key)}
														/>
														<StyledTypography sx={{ fontSize: '14px', fontWeight: '600' }}>
															{phone?.key.charAt(0).toUpperCase() + phone?.key.slice(1)}
														</StyledTypography>
													</Stack>
													<Stack flexDirection="row" gap={1} className="w-[65%]">
														<Typography
															className="text-left"
															sx={{
																color: "#15194B",
																fontWeight: "400",
																fontSize: "14px",
															}}
														>
															{number}
														</Typography>
													</Stack>
												</Grid>
												<Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
													<CallButton
														balance={balance}
														callType={"phone"}
														from={props.emailAddress}
														to={phone.value}
														closeCallHistory={() => {
															console.log("close history");
														}}
														localCall={
															contact.contactType === "local" ? "local" : null
														}
														toUserId={contact.userId}
														toName={contact.userName}
														openGetRecharge={() => props.openRecharge()}
													>
														<CachedImage
															id="callgoing"
															imgKey="callgoing"
															image={COMMON_CALL_ICON}
															width="14px"
															style={{
																width: "25px",
																height: "25px",
																borderRadius: "50%",
															}}
														/>
													</CallButton>
												</Grid>
											</Grid>
											{(phoneNumbers.length >= 1) && <Divider flexItem />}
										</React.Fragment>
									);
								}

							})}

						{hasValidEmail && (
							<>
								{!contact.contactType && contact.emailAddress !== "" && (
									<Grid container className="justify-between w-full">
										<Grid className="flex gap-3 lg:w-[80%] xl:w-[60%]">
											<Stack flexDirection="row" gap={1} className="xl:w-[35%] lg:w-[40%]" >
												<CachedImage
													id="mailicon"
													imgKey="mailicon"
													image={MAIL_ICON}
													width="14px"
													style={{
														width: "26px",
														height: "26px",
														borderRadius: "50%",
													}}
													onClick={() => {
														console.log("uzma checking");
													}}
												/>
												<Typography
													sx={{
														fontSize: "14px",
														fontWeight: 600,
														fontFamily: 'Figtree-Regular',
														color: "#15194B",
													}}
												>
													Email
												</Typography>
											</Stack>

											<Typography
												className="text-left w-[65%]"
												sx={{
													color: "#15194B",
													fontSize: "14px",
													fontFamily: 'Figtree-Regular',
													fontWeight: "400",
												}}
											>
												{contact.emailAddress}
											</Typography>
										</Grid>
										<Grid className="">
											<CachedImage
												id="blue"
												imgKey="blue"
												image={BLUE_MAIL_ICON}
												style={{
													width: "25px",
													height: "25px",
													borderRadius: "50%",
												}}
												onClick={() => {
													window.location.href = `mailto:${contact?.emailAddress}`;
												}}
											/>
										</Grid>
									</Grid>
								)}
								{contact?.emailAddresses &&
									contact?.contactType === "local" &&
									Object.keys(contact.emailAddresses).map((elem, index) => {
										return (
											contact.emailAddresses[elem] &&
											contact.emailAddresses[elem].length > 0 && (
												<Grid container key={index} className="justify-between w-full">
													<Grid className="flex gap-3 lg:w-[80%] xl:w-[60%]">
														<Stack
															flexDirection="row"
															alignItems="center"
															gap={1}
															className="xl:w-[35%] lg:w-[40%]"
														>
															<CachedImage
																id="mailicon"
																imgKey="mailicon"
																image={MAIL_ICON}
																width="14px"
																style={{
																	width: "26px",
																	height: "26px",
																	borderRadius: "50%",
																}}
															/>
															<Typography
																sx={{
																	fontSize: "14px",
																	fontWeight: 600,
																	fontFamily: 'Figtree-Regular',
																	color: "#15194B",
																}}
																className="w-[65%]"
															>
																Email
															</Typography>
														</Stack>

														<Typography
															className="text-left"
															sx={{
																color: "#15194B",
																fontSize: "14px",
																fontFamily: 'Figtree-Regular',
																fontWeight: "400",
															}}
														>
															{contact.emailAddresses[elem]}
														</Typography>
													</Grid>
													<Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
														<CachedImage
															id="blue"
															imgKey="blue"
															image={BLUE_MAIL_ICON}
															style={{
																width: "25px",
																height: "25px",
																borderRadius: "50%",
																cursor: "pointer",
															}}
															onClick={() => {
																window.location.href = `mailto:${contact.emailAddresses[elem]}`;
															}}
														/>
													</Grid>
												</Grid>
											)
										);
									})}
								{hasValidEmail && <Divider flexItem />}
							</>
						)}

						{contact.nationality && (
							<Grid container gap={20} justifyContent={"start"} className="w-full">
								<Grid className="flex lg:w-[80%] xl:w-[60%]" >
									<Stack flexDirection="row" gap={1} className="xl:w-[35%] lg:w-[40%]">
										<CachedImage
											id="flagicon"
											imgKey="flagicon"
											image={FLAG_ICON}
											style={{
												width: "26px",
												height: "26px",
												borderRadius: "50%",
											}}
										/>
										<Typography sx={{ fontSize: "14px", fontFamily: 'Figtree-Regular', fontWeight: 600, color: '#15194B', }}>
											Nationality
										</Typography>
									</Stack>

									<Typography
										className="text-left w-[65%]"
										sx={{ fontSize: "14px", fontFamily: 'Figtree-Regular', fontWeight: 400 }}
									>
										{contact.nationality}
									</Typography>
								</Grid>
							</Grid>
						)}

						{contact.userCompanyName && (
							<Grid container gap={20} justifyContent={"start"} className="w-full">
								<Grid className="flex lg:w-[80%] xl:w-[60%]">
									<Stack flexDirection="row" gap={1} className="xl:w-[35%] lg:w-[40%]">
										<CachedImage
											id="companyicon"
											imgKey="companyicon"
											image={COMPANY_ICON}
											style={{
												width: "26px",
												height: "26px",
												borderRadius: "50%",
											}}
										/>
										<Typography
											sx={{
												fontSize: "14px",
												fontWeight: 600,
												fontFamily: 'Figtree-Regular',
												color: "#15194B",
											}}
											className=" text-left"
										>
											Company
										</Typography>
									</Stack>

									<Typography
										className="text-left w-[65%]"
										sx={{ fontSize: "14px", fontWeight: 400, fontFamily: 'Figtree-Regular' }}
									>
										{contact.userCompanyName}
									</Typography>
								</Grid>
							</Grid>
						)}
						{contact.shipIMO && (
							<Grid container gap={20} justifyContent={"start"} className="w-full">
								<Grid className="flex lg:w-[80%] xl:w-[60%]">
									<Stack flexDirection="row" gap={1} className="xl:w-[35%] lg:w-[40%]">
										<CachedImage
											id="shipimoicon"
											imgKey="shipimoicon"
											image={SHIPP_ICON}
											style={{
												width: "26px",
												height: "26px",
												borderRadius: "50%",
											}}
										/>
										<Typography
											variant="subtitle1"
											sx={{ fontSize: "14px", fontWeight: 600, fontFamily: 'Figtree-Regular', color: '#15194B', }}
										>
											Ship IMO
										</Typography>
									</Stack>

									<Typography
										className="text-left"
										sx={{ fontSize: "14px", fontWeight: 400, fontFamily: 'Figtree-Regular' }}
									>
										{contact.shipIMO}
									</Typography>
								</Grid>
							</Grid>
						)}
						{contact.address &&
							(contact.address.addressLine1 ||
								contact.address.addressLine2) && (
								<Grid container gap={20} justifyContent={"start"} className="w-full">
									<Grid className="flex lg:w-[80%] xl:w-[60%]" >
										<Stack flexDirection="row" gap={1} className="xl:w-[35%] lg:w-[40%]">
											<CachedImage
												id="addresssicon"
												imgKey="addresssicon"
												image={HOME_ICON}
												style={{
													width: "26px",
													height: "26px",
													borderRadius: "50%",
												}}
											/>
											<Typography
												className="text-left"
												variant="subtitle1"
												sx={{ fontSize: "14px", fontWeight: 600, fontFamily: 'Figtree-Regular', color: '#15194B' }}
											>
												Address
											</Typography>
										</Stack>

										{contact.address.addressLine1 && (
											<Typography
												className="text-left w-[65%]"
												sx={{
													fontSize: "14px",
													fontWeight: 400,
													fontFamily: 'Figtree-Regular',
													wordWrap: "break-word",
													width: "65%",
												}}
											>
												{contact.address.addressLine1}
											</Typography>
										)}
										{contact.address.addressLine2 && (
											<Typography
												className="text-left w-[65%]"
												sx={{
													fontSize: "14px",
													fontFamily: 'Figtree-Regular',
													fontWeight: 400,
													wordWrap: "break-word",
													width: "100%",
												}}
											>
												{contact.address.addressLine2}
											</Typography>
										)}
									</Grid>
								</Grid>
							)}
					</Stack>}

					{contact.showAcceptIgnoreMsg && !contact?.isLocalContact && (
						<>
							<div className="p-2 d-inline-flex justify-content-around align-items-center mt-2 ">
								<h4 style={{ marginLeft: "20px", color: "#B9B9B9" }}>
									Hold tight! We're waiting for your contact's approval. Once they accept, you'll be able to view their profile details
								</h4>
							</div>

							<Stack
								flexDirection="row"
								gap="1rem"
								justifyContent="space-around"
								sx={{ width: "100%", marginTop: "3rem" }}
							>
								<DeclineButton
									variant="outlined"
									onClick={() => props.ignore(contact.userId)}
								>
									Decline
								</DeclineButton>

								<WelcomeButton
									variant="contained"
									onClick={() => props.accept(contact.userId)}
								>
									Accept
								</WelcomeButton>
							</Stack>
						</>
					)}

					{noteSection}

					{contact.contactType === "local" && !showEditForm && (
						<Button onClick={() => setAddContactMenu(true)}
							variant="contained"
							sx={{
								backgroundColor: "#376afa",
								padding: "4px 30px",
								textTransform: "capitalize",
								fontFamily: 'Figtree-Regular',
								"&:hover": { backgroundColor: "#376afa" },
							}}
						>
							Invite to <span className="lowercase ml-1">{selectedDomain?.userDomain}</span>
						</Button>
					)}

					{!contact.type && !showEditForm && (
						<Stack
							flexDirection="row"
							justifyContent="center"
							className="px-4 pt-4"
							sx={{ pb: 12, mb: 4 }}
						>
							<Stack flexDirection='row' alignItems='center' justifyContent='center'
								className="warning-text"
								sx={{ cursor: "pointer" }}
								onClick={() => props.remove(contact)}
							>
								<img className="warning-text mr-1" src="/img/deleteIcon.svg" width={25} height={25} />
								<Typography sx={{ fontFamily: 'Figtree-Regular', fontSize: '14px', fontWeight: '600' }}>Delete contact</Typography>
							</Stack>
						</Stack>
					)}
				</CustomBox>
			</Scrollbars>
		</div>
	);
};

export default ContactDetailsFunctional;